// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.fine-prompt {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  z-index: 50;
}
.fine-prompt__window {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  pointer-events: auto;
  width: 380px;
  max-width: 92%;
  display: flex;
  flex-direction: column;
  padding: 20px 22px 18px;
}
.fine-prompt__window * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .fine-prompt__window {
    animation: none;
  }
}
.fine-prompt__header {
  display: block;
  margin-bottom: 4px;
}
.fine-prompt__icon {
  display: none;
}
.fine-prompt__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}
.fine-prompt__target {
  margin: 0 0 16px;
  font-size: 14px;
  line-height: 1.5;
  color: #aeaba2;
}
.fine-prompt__label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
}
.fine-prompt__input {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  font-size: 15px;
}
.fine-prompt__input:focus {
  outline: none;
  border-color: var(--gold-main);
}
.fine-prompt__input::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.fine-prompt__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
}
.fine-prompt__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.fine-prompt__button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.fine-prompt__button:active:not(:disabled) {
  transform: translateY(1px);
}
.fine-prompt__button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.fine-prompt__button:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.fine-prompt__button:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.fine-prompt__button--secondary {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: rgba(255, 255, 255, 0.2);
}
.fine-prompt__button--secondary:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/components/FinePrompt/FinePrompt.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AANA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,yDDiBU;EChBV,WAAA;AAQF;AANE;EDiBA,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;EC3JE,oBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAcJ;ADHE;EAAI,sBAAA;ACMN;ADuIE;EChKA;IDgK0C,eAAA;ECnI1C;AACF;AAnBE;EACE,cAAA;EACA,kBAAA;AAqBJ;AAjBE;EAAU,aAAA;AAoBZ;AAlBE;EDqBA,kDA3BW;EA4BX,gBAAA;EACA,eCvB8B;EDwB9B,iBAAA;EACA,sBAAA;EACA,cAxCK;ACwCP;AAxBE;EACE,gBAAA;ED2BF,eAAA;EACA,gBAAA;EACA,cA7CO;AC6CT;AAzBE;EACE,cAAA;EACA,kBAAA;EDiCF,eAAA;EACA,gBAAA;EACA,cAzDO;ACoDT;AA1BE;EDyFA,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;EC/FE,eAAA;AAoCJ;AD6DE;EAAU,aAAA;EAAe,8BAAA;ACzD3B;AD0DE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACnD1G;AA5CE;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,gBAAA;AA8CJ;AA3CE;EDwBA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EASA,cAjFU;EAkFV,4BAAA;EACA,8BAAA;ACcF;ADvBE;EAAyB,qCAAA;EAAuC,8BAAA;AC2BlE;AD1BE;EAA0B,0BAAA;AC6B5B;AD5BE;EAAa,YAAA;EAAc,mBAAA;ACgC7B;AD/BE;EAAkB,oCAAA;EAAsC,mBAAA;ACmC1D;AD3BE;EAAyB,6BAAA;EAA+B,+BAAA;AC+B1D;AA/EI;EACE,cD5CC;EC6CD,qCAAA;EACA,sCD/CQ;ACgId;AA/EM;EAAyB,cDhDxB;ECgD0C,qCAAA;EAAuC,8BAAA;AAoFxF","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// Centred prompt asking the guard for the fine amount.\n.fine-prompt {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  font-family: ink.$font-text;\n  z-index: 50;\n\n  &__window {\n    @include ink.panel;\n    @include ink.enter;\n    pointer-events: auto;\n    width: 380px;\n    max-width: 92%;\n    display: flex;\n    flex-direction: column;\n    padding: 20px 22px 18px;\n  }\n\n  &__header {\n    display: block;\n    margin-bottom: 4px;\n  }\n\n  // Decorative glyph, no longer displayed.\n  &__icon { display: none; }\n\n  &__title { @include ink.title(22px); }\n\n  &__target {\n    margin: 0 0 16px;\n    @include ink.lead;\n  }\n\n  &__label {\n    display: block;\n    margin-bottom: 6px;\n    @include ink.label;\n  }\n\n  &__input {\n    @include ink.field;\n    font-size: 15px;\n  }\n\n  &__footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    margin-top: 20px;\n  }\n\n  &__button {\n    @include ink.button;\n    @include ink.button-primary;\n\n    &--secondary {\n      color: ink.$text;\n      background: rgba(255, 255, 255, 0.07);\n      border-color: ink.$line-strong;\n\n      &:hover:not(:disabled) { color: ink.$text; background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
